import React, { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles
} from '@material-ui/core';
import {
  BarChart as BarChartIcon,
  User as UserIcon,
  Users as UsersIcon,
  Tool as ToolIcon,
  FileText as FileTextIcon,
  Calendar as CalendarIcon,
  LogOut,
} from 'react-feather';
import NavItem from './NavItem';

const user = {
  avatar: '/static/images/avatars/avatar-generic.png',
  jobTitle: 'Administrador',
  name: 'Gustavo Braz'
};

const adminItems = [
  {
    href: '/app/central',
    icon: BarChartIcon,
    title: 'Dashboard'
  },
  {
    href: '/app/pessoas',
    icon: UserIcon,
    title: 'Pessoas'
  },
  {
    href: '/app/demandas',
    icon: FileTextIcon,
    title: 'Demandas'
  },
  
  {
    href: '/app/agenda',
    icon: CalendarIcon,
    title: 'Agenda'
  },
  /*{
    href: '/app/pecas',
    icon: PackageIcon,
    title: 'Categorias de manutenção'
  }, */
  {
    href: '/app/usuarios',
    icon: UsersIcon,
    title: 'Gerenciar Usuários'
  },
  {
    href: '/app/perfil',
    icon: ToolIcon,
    title: 'Código do Gabinete'
  },
  {
    href: '/app/sair',
    icon: LogOut,
    title: 'Sair'
  },
];

const items = [
  {
    href: '/app/central',
    icon: BarChartIcon,
    title: 'Dashboard'
  },
  {
    href: '/app/pessoas',
    icon: UserIcon,
    title: 'Pessoas'
  },
  {
    href: '/app/demandas',
    icon: FileTextIcon,
    title: 'Demandas'
  },
  
  {
    href: '/app/agenda',
    icon: CalendarIcon,
    title: 'Agenda'
  },
  /*{
    href: '/app/pecas',
    icon: PackageIcon,
    title: 'Categorias de manutenção'
  }, */
  /* {
    href: '/app/usuarios',
    icon: UsersIcon,
    title: 'Gerenciar Usuários'
  }, */
  /* {
    href: '/app/perfil',
    icon: SettingsIcon,
    title: 'Perfil'
  }, */
  {
    href: '/app/sair',
    icon: LogOut,
    title: 'Sair'
  },
];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile, currentUser, userRole }) => {
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const isAdmin = () => {
    if (userRole === 'admin') return adminItems;
    else return items;
  };

  const getUserRole = () => {
    switch (userRole) {
      case 'admin':
        return 'Administrador';
      case 'manager':
        return 'Gestor';
      case 'normal':
        return 'Colaborador';
      default: return '';
    }
  }

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        p={2}
      >
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          src={user.avatar}
          to="/app/perfil"
        />
        <Typography
          className={classes.name}
          color="textPrimary"
          variant="h5"
        >
          {currentUser ? currentUser.email : ''}
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
        >
          {getUserRole()}
        </Typography>
      </Box>
      <Divider />
      <Box p={2}>
        <List>
          {isAdmin().map((item) => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          ))}
        </List>
      </Box>
      <Box flexGrow={1} />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default NavBar;
